import React, { Component } from 'react';
import TimeRange from '../util/getTimeRange';
import nProgress from 'nprogress';
import server from '../util/apiService';
export default class Filter extends Component {
    render () {
            return (
                    <div id="filter-container">
                        <div id="filter-2" className="filter">
                            <select value={this.props.timeSelectorValue} id="timeSelector" onChange={(e) => {this.handleChangeForTime(e)}}>
                                <option disabled value="line">--------------------</option>
                                <option value="January">Jan 2016</option>
                                <option value="February">Feb 2016</option>
                                <option value="March">Mar 2016</option>
                                <option value="April">Apr 2016</option>
                                <option value="May">May 2016</option>
                                <option value="June">Jun 2016</option>
                                <option value="July">Jul 2016</option>
                                <option value="August">Aug 2016</option>
                                <option value="September">Sep 2016</option>
                                <option value="October">Oct 2016</option>
                                <option value="November">Nov 2016</option>
                                <option value="December">Dec 2016</option>
                                <option disabled value="line">--------------------</option>
                                <option value="Q1">Q1 2016</option>
                                <option value="Q2">Q2 2016</option>
                                <option value="Q3">Q3 2016</option>
                                <option value="Q4">Q4 2016</option>
                                <option disabled value="line">--------------------</option>
                                <option value="H1">H1 2016</option>
                                <option value="H2">H2 2016</option>
                                <option disabled value="line">--------------------</option>
                            </select>
                        </div>
                </div>
            )
    }
    
    handleChangeForTime(event) {
            nProgress.start();
            nProgress.inc(0.2);

            let timeSelectorValue = event.target.value, 
            timeRangeObject = new TimeRange().getTimeRange(timeSelectorValue),
            data = [], 
            shipperData = [];

            this.setState({timeSelectorValue: timeSelectorValue});
            this.props.handleDataChange([]);

            if (window.sessionStorage[timeSelectorValue]) {
                data = JSON.parse(window.sessionStorage[timeSelectorValue]);
                shipperData = JSON.parse(window.sessionStorage['allShipperData'+timeSelectorValue]);
                this.props.handleFilterDropdown(timeSelectorValue, data);
                this.props.handleAllShipperData(shipperData);
                nProgress.done();
            } else {
            server.get('/api?startTime=' + timeRangeObject.startTime + '&endTime=' + timeRangeObject.endTime, {
                headers: {'Access-Control-Allow-Origin': '*'}
            })
            .then((response) => {
                data = response.data;
                this.props.handleFilterDropdown(timeSelectorValue, data);
                window.sessionStorage[timeSelectorValue] = JSON.stringify(data, null, 4);
                nProgress.done();
            })
                .catch((error) => {
                console.log(error);
            });
            server.get('/api/all?startTime=' + timeRangeObject.startTime + '&endTime=' + timeRangeObject.endTime)
            .then((response) => {
                data = response.data;
                this.props.handleAllShipperData(data);
                window.sessionStorage['allShipperData'+timeSelectorValue] = JSON.stringify(data, null, 4);
            })
            .catch((error) => {
              console.log(error);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Filter.js